import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconReport(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M18 13a8 8 0 1 1-8-8h1v7h7v1Zm-8 6a6.002 6.002 0 0 0 5.917-5H9V7.084A6.002 6.002 0 0 0 10 19Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M21 9v1h-8V2h1a7 7 0 0 1 7 7Zm-6-1h3.9A5.006 5.006 0 0 0 15 4.1V8Z"
        clipRule="evenodd"
      />
    </BaseIcon>
  );
}
